import React, { useState } from "react";
import "./SubscriptionDropdown.css";

const options = [
  { label: "1 month", value: "1" },
  { label: "12 months", value: "12" },
  { label: "24 months", value: "24" },
  { label: "48 months", value: "48", badge: "Best Value" },
];

const SubscriptionDropdown = () => {
  const [selected, setSelected] = useState(options[3]); // Default: 48 months
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectOption = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  return (
    <div className="sub-wrapper">
      <p className="sub-label">Length of subscription</p>
      <div className={`sub-dropdown ${isOpen ? "open" : ""}`} onClick={toggleDropdown}>
        <div className="sub-selected">
          <span>{selected.label}</span>
          <span className={`arrow ${isOpen ? "up" : "down"}`}>▾</span>
        </div>
        {isOpen && (
          <div className="sub-options">
            {options.map((opt) => (
              <div
                key={opt.value}
                className={`sub-option ${
                  selected.value === opt.value ? "selected" : ""
                }`}
                onClick={() => selectOption(opt)}
              >
                <span>{opt.label}</span>
                {opt.badge && (
                  <span className={`badge ${selected.value === opt.value ? "active" : ""}`}>
                    {opt.badge}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionDropdown;
